import { useEffect, useMemo } from "react";
import { useGetBillingPlans, useGetBillingSubscriptions } from "@piiqtechnologies/ui-lib";
import { useAuthContext } from "@stores/AuthContext";
import { BILLING_STATUS } from "@constants/BillingStatus";
import { buildReportTypePrices } from "./constants/reportTypes";
export const useReportTypePrices = () => {
    var _a;
    const { user } = useAuthContext();
    const orgId = (_a = user === null || user === void 0 ? void 0 : user.organization) === null || _a === void 0 ? void 0 : _a._id;
    const [fetchPlans, apiPlans, , plansError] = useGetBillingPlans();
    const [fetchSubscriptions, subscriptions, , subscriptionsError] = useGetBillingSubscriptions();
    useEffect(() => {
        if (orgId) {
            fetchPlans(orgId);
            fetchSubscriptions(orgId);
        }
    }, [orgId, fetchPlans, fetchSubscriptions]);
    const prices = useMemo(() => buildReportTypePrices(apiPlans), [apiPlans]);
    // The first-report-free coupon is once per org (enforced server-side). Mirror that here so
    // the promo copy only shows on the org's first Basic monthly purchase — i.e. while it has no
    // non-incomplete Basic monthly subscription. CheckoutContent applies the same eligibility check.
    const firstReportFreeEligible = useMemo(() => {
        var _a;
        const basicMonthlyPriceId = (_a = apiPlans === null || apiPlans === void 0 ? void 0 : apiPlans.find((p) => p.tier === "basic" && p.interval === "monthly")) === null || _a === void 0 ? void 0 : _a.priceId;
        if (!basicMonthlyPriceId || !subscriptions)
            return true;
        return !subscriptions.some((sub) => sub.status !== BILLING_STATUS.INCOMPLETE && sub.stripePriceId === basicMonthlyPriceId);
    }, [apiPlans, subscriptions]);
    const loading = Boolean(orgId) && ((apiPlans == null && !plansError) || (subscriptions == null && !subscriptionsError));
    return { prices, loading, firstReportFreeEligible };
};
